// Six public service-discovery groups (Sep 2026). Customer-facing labels
// only — services keep their own canonical slugs/URLs. Tiles opt into one
// or more groups via `finder_items[].discovery_groups` (CMS-editable).
export const DISCOVERY_GROUPS = [
  { key: "branding", label: "Branding" },
  { key: "print-signage", label: "Print & Signage" },
  { key: "digital-ads", label: "Digital & Ads" },
  // Retired Oct 2026: kept for admin/historical data, hidden publicly.
  { key: "websites", label: "Websites", retired: true },
  { key: "packaging", label: "Packaging" },
  { key: "3d-motion", label: "3D & Motion" },
];

// Public-facing groups (homepage, /services chips, portfolio filters).
export const PUBLIC_DISCOVERY_GROUPS = DISCOVERY_GROUPS.filter((g) => !g.retired);

export const groupLabel = (key) => DISCOVERY_GROUPS.find((g) => g.key === key)?.label || "";
